import React from 'react'
import ProductsLogic from './ProductsLogic'
import ProductsLayout from './ProductsLayout'

const Products = () => {
  return <ProductsLogic Wrapper={ProductsLayout} />
}

export default Products
